/**
 * @param customLocale country locale
 * @returns compare function for sorting
 */
export function competitionOrderCompareMethod(locale) {
    return new Intl.Collator(locale, {
        numeric: true,
        sensitivity: "base"
    }).compare;
}
